import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { EMPTY_QUERY_PARAM } from "@l2r-front/l2r-query"
import { sortCatalogChildTypes } from "@l2r-front/l2r-utils"

import { horizontalSigningQueryKeys } from "./queryKeys"
import { useHorizontalSigningQuery } from "./useHorizontalSigningQueries"

export function useHorizontalSignTypes(parent = EMPTY_QUERY_PARAM, config = {}) {
    const url = "horizontal_sign_types/"
    const { selectedNetwork } = useNetworksStateContext()
    const { country } = selectedNetwork

    const parameters = {
        country,
        parent: parent || EMPTY_QUERY_PARAM,
    }

    const queryKey = horizontalSigningQueryKeys.list(parameters)

    const { data, isLoading, isError, isFetching } = useHorizontalSigningQuery(
        url,
        queryKey,
        parameters,
        {
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        data.sort((a, b) => a.code.localeCompare(b.code))
        data.forEach(d => sortCatalogChildTypes(d))
    }

    return { data, isLoading, isError, isFetching }
}

export function useHorizontalSignType(code, queryParameters, config = {}) {
    const url = `horizontal_sign_types/${code}/`
    const queryKey = horizontalSigningQueryKeys["horizontalSignType"]({ ...queryParameters, code })

    const { data, isLoading, isError } = useHorizontalSigningQuery(
        url,
        queryKey,
        { ...queryParameters },
        {
            enabled: !!code,
            ...config,
            autoRefetch: true,
        },
    )

    if (data) {
        sortCatalogChildTypes(data)
    }

    return { data, isLoading, isError }
}